import {
  ReporteAsesorMockUp,
  ResumenAsesorMockUp
} from "./ReporteAsesor.types";

export const mockResumen: ResumenAsesorMockUp = {
  ventasYReactivaciones: 16,
  integrantes: 3,
  integrantesConCargo: 8,
  descuentos: -4,
  verMembresias: true,
  alcance: 85.18
};

export const mockData: ReporteAsesorMockUp[] = [
  {
    club: "Saltillo",
    membresia: "4851",
    tipoMembresia: "Individual",
    evaluacion: "Sin alcance",
    tipoVenta: "Reactivacion",
    descripcion: "Reactivacion t..."
  },
  {
    club: "San Pedro",
    membresia: "4852",
    tipoMembresia: "Oro",
    evaluacion: "Sin pago",
    tipoVenta: "Membresia",
    descripcion: "Venta de m..."
  },
  {
    club: "Anauco",
    membresia: "4853",
    tipoMembresia: "Plata",
    evaluacion: "Aceptada",
    tipoVenta: "Integrante",
    descripcion: "Consejo actu..."
  }
];
